<template>
    <v-container grid-list-xl :class="$vuetify.breakpoint.smAndDown ? 'px-0' : ''">
        <stepper class="elevation-0" @input="refreshMeta" ref="stepper">
            <v-stepper-header class="elevation-0" v-show="!hideHeader">
                <v-stepper-step :step="1">{{ 'address' | translation }}</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :step="2">{{ 'Payment' | translation }}</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :step="3">{{ 'Finished' | translation }}</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <address-step :step="1" house-number-required></address-step>
                <summary-step :step="2" @onNextStep="onPaymentSuccess" flat-cards />
                <payment-processing-step :step="2.5" @onNextStep="onPaymentSuccess"></payment-processing-step>
                <success-step :step="3" :order="order" route="success"></success-step>
            </v-stepper-items>
        </stepper>
    </v-container>
</template>

<script>
import Vue from 'vue';
import AddressStep from './AddressStep/AddressStep';
import SummaryStep from './SummaryStep/SummaryStep';
import PaymentProcessingStep from '@breakmedia/prime-vue-checkout/src/PaymentProcessingStep';
import CheckoutRegistrationDefault from './AddressStep/Registration/default/Registration';
import BillingAddressDefault from './AddressStep/BillingAddress';
import ShippingAddressDefault from '@breakmedia/prime-vue-checkout/src/AddressStep/ShippingAddress';
import Checkout from '@breakmedia/prime-vue-checkout/src/Checkout';
import billingAddressModule from './AddressStep/store/billingAddress';

const moduleName = 'Checkout';

if (!Vue.$store.state['BillingAddressForm']) {
    Vue.$store.registerModule('BillingAddressForm', billingAddressModule);
}

export default {
    name: moduleName,
    extends: Checkout,
    components: {
        AddressStep,
        SummaryStep,
        PaymentProcessingStep,
    },
    beforeCreate() {
        if (!Vue.options.components['checkout-billing-address-default']) {
            Vue.component('checkout-billing-address-default', BillingAddressDefault);
        }
        if (!Vue.options.components['checkout-shipping-address-default']) {
            Vue.component('checkout-shipping-address-default', ShippingAddressDefault);
        }
        if (!Vue.options.components['checkout-registration-default']) {
            Vue.component('checkout-registration-default', CheckoutRegistrationDefault);
        }
    },
};
</script>
